import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from "ui/CenteredWrapper";
import Heading from "ui/Heading";
import { FlexItem, HR } from "components/forms/Forms.styles";
import RelayPromptForm from "./ReplayPromptForm";
import AccessDenied from "components/AccessDenied";

function RelayPromptDetailPage() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const navigate = useNavigate();
  const { promptId } = useParams();
  const [promptData, setPromptData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    api
      .get(`${API_BASE}/api/relay-prompt/find?promptId=${promptId}`)
      .then((res) => {
        // console.log('============= fetch prompt details response: ', res);
        if (res.status == 200) {
          // if (res.data?.code == '401001') {
          //   navigate('/access-denied');
          // }
          setPromptData(res.data);
        }
      })
      .catch(() =>
        console.log("failed to fetch prompt details data, promptId: ", promptId)
      );
  }, [promptId]);

  const updatePrompt = (values, status) => {
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/relay-prompt/update`, { ...values, status })
      .then((res) => {
        if (res.status == 200 && status === 2) {
          // const promptId = res.data.data;
          // console.log(promptId);
          navigate("/admin/management/relay-prompt");
        }
      })
      .catch(() => alert("Failed to update relay prompt, promptId: ", promptId))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h4">Relay Prompt Details</Heading>
      </FlexItem>
      <HR className="light" />
      <RelayPromptForm
        data={promptData}
        updatePrompt={updatePrompt}
        isDisabled={isSubmitting}
        // isEdit={true}
      />
    </CenteredWrapper>
  );
}

export default RelayPromptDetailPage;
